import React, { useState } from 'react';
import { userCourseDeleteUser } from 'Api/editCourseMembers';

const useDeleteUser = (courseUsers, setCourseUsers, courseId, setOpenModal, setOpen, setOpenError) => {
  const [userToDelete, setUserToDelete] = useState();
  const confirmationDeleteUser = user => {
    setUserToDelete(user);
    setOpenModal(true);
  };

  const deleteUser = async () => {
    const userId = userToDelete[5];

    const response = await userCourseDeleteUser(courseId, userId);

    if (response.status) {
      setCourseUsers(courseUsers.filter(course => course[5] !== userId));
      setOpen(true);
    } else {
      setOpen(true);
      setOpenError(true);
    }
  };

  return { deleteUser, confirmationDeleteUser };
};

export default useDeleteUser;
